"use client";
import Link from "next/link";
import React from "react";
import { useMediaQuery } from "@/app/hooks/useMediaQuery";

export const PlanningTransport = () => {
  const isMobile = useMediaQuery("(max-width:1024px)");

  if (isMobile === null) {
    return (
      <div className="bg-red py-[120px]" aria-hidden="true" />
    );
  }

  return (
    <>
      {isMobile ? (
        <div className="bg-red py-[200px] flex flex-col items-center justify-center">
          <p className="w-[184px] text-[#fff] mb-[34px] uppercase text-[24px] leading-[24px] text-center">
            Rent <br /> a charter bus today
          </p>
          <Link
            href="#quote-page"
            className="bg-[#fff] text-red px-1/2 dt:px-[24px] py-[12px] rounded-[8px] uppercase font-bold text-[16px] leading-[16px] dt:leading-[24px] tracking-wider block mx-auto w-fit mb-[34px]"
          >
            GET A QUOTE
          </Link>
          <a
            href={`tel:888 612-1308`}
            className="text-white rounded-1/2 uppercase font-normal text-[16px] leading-[16px]tracking-wider text-center hidden max-[560px]:block"
          >
            OR CALL <span className="font-bold">(888) 612-1308</span>
          </a>
        </div>
      ) : (
        <div className="bg-red py-[71px] flex items-center justify-center">
          <div className="flex items-center justify-center">
            <h2 className="uppercase font-bold text-[#fff] text-[24px] leading-[24px] tracking-[0.04em] mr-[16px]">
              planning transportation? we&apos;ll help!
            </h2>
            <Link
              href="#quote-page"
              className="bg-[#fff] text-red px-1/2 dt:px-[24px] py-[12px] rounded-[8px] uppercase font-bold text-[16px] leading-[16px] tracking-wider block w-fit"
            >
              GET A QUOTE
            </Link>
          </div>
        </div>
      )}
    </>
  );
};
